var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pms-search-bar"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"search-actions"},[_vm._t("actions")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }